import apiHelper from '@/services/helper'
import { serverConfig } from '@/config/serverConfig.js'
import axios from 'axios'
const tokenT = 'Basic 1wkdsfjKFJFDI84640jfFir8'

const getListCase = async (statusId, flagId, startDate, endDate, limit, offset) => {
    try {
        let url = '/admin/case-tracking/get-all?status_id=' + statusId + '&flag_id=' + flagId + '&start_date=' + startDate + '&end_date=' + endDate + '&limit=' + limit + '&offset=' + offset
        console.log(url)
        let apiUrl = serverConfig.linkFetchUrl + '' + url

        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListPriorities = async () => {
    try {
        let url = '/admin/case-tracking/priorities'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListsSatus = async () => {
    try {
        let url = '/admin/case-tracking/status'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListsReasons = async () => {
    try {
        let url = '/admin/case-tracking/reasons'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        console.log(respone)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListsflagCases = async () => {
    try {
        let url = '/admin/case-tracking/flag-cases'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getCountCaseByStatus = async (flagId, startDate, endDate) => {
    try {
        let url = '/admin/case-tracking/count-cases-by-status' + '?flag_id=' + flagId + '&start_date=' + startDate + '&end_date=' + endDate
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getCountCaseByLate = async (flagId) => {
    try {
        let url = '/admin/case-tracking/count-late-cases' + '?flag_id=' + flagId
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const updateCase = async (decamelizedData) => {
    try {
        let url = '/admin/case-tracking/update'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        // let response = await doPostAxios(apiUrl, decamelizedData, tokenT)
        const response = await axios.post(apiUrl, decamelizedData,
            { headers: { Authorization: tokenT } })
        return response.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListNotify = async (date) => {
    try {
        let url = '/admin/case-tracking/customers/notification-status?date=' + date
        let apiUrl = serverConfig.linkFetchUrl + '' + url

        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const updateNotify = async (decamelizedData) => {
    try {
        let url = '/admin/case-tracking/customer-supports/notify'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        // let response = await doPostAxios(apiUrl, decamelizedData, tokenT)
        const response = await axios.post(apiUrl, decamelizedData,
            { headers: { Authorization: tokenT } })
        return response.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListCustomerCS = async (date) => {
    try {
        let url = '/admin/case-tracking/customers/supports'
        let apiUrl = serverConfig.linkFetchUrl + '' + url

        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const updateCustomerCs = async (decamelizedData) => {
    try {
        let url = '/admin/case-tracking/customers/update-support'
        let apiUrl = serverConfig.linkFetchUrl + '' + url
        // TODO response.data
        // let response = await doPostAxios(apiUrl, decamelizedData, tokenT)
        const response = await axios.post(apiUrl, decamelizedData,
            { headers: { Authorization: tokenT } })
        return response.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListCsProfile = async (limit, offset, date) => {
    try {
        let url = '/admin/case-tracking/customer-supports' + '?limit=' + limit + '&offset=' + offset
        let apiUrl = serverConfig.linkFetchUrl + '' + url

        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListCsProfileAll = async () => {
    try {
        let url = '/admin/case-tracking/customer-supports'
        let apiUrl = serverConfig.linkFetchUrl + '' + url

        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

const getListCsPerformance = async (limit, offset, date) => {
    try {
        let url = '/admin/case-tracking/customer-supports/count-cases' + '?limit=' + limit + '&offset=' + offset + '&date=' + date
        console.log(url)
        let apiUrl = serverConfig.linkFetchUrl + '' + url

        let respone = await apiHelper.doGetAxios(apiUrl, tokenT)
        return respone.data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getListCase,
    getListPriorities,
    getListsSatus,
    getListsReasons,
    getListsflagCases,
    getCountCaseByStatus,
    getCountCaseByLate,
    updateCase,
    getListNotify,
    updateNotify,
    getListCustomerCS,
    updateCustomerCs,
    getListCsProfile,
    getListCsProfileAll,
    getListCsPerformance
}
